import { Loading } from "./Loading";

type SuspenseProps = {
    children: ReactNode;
    isLoading: boolean;
    size?: number;
    fallback?: ReactNode;
};

export function Suspense(props: SuspenseProps) {
    const { isLoading, children, size, fallback = <Loading size={size} /> } = props;

    if (isLoading) return fallback;

    return children;
}
